<div class = "unit-centered" *ngIf="loading">
	<div class = "unit-solar"></div>
	<div class = "unit-top"></div>
	<div class = "unit-1"></div>
	<div class = "unit-1-base"></div>
	<div class = "unit-2"></div>
	<div class = "unit-3"></div>
	<div class = "unit-4"></div>
</div>
